import React from "react";
import "./DeleteConfirmationDialog.css";

/* eslint-disable react/prop-types */
const DeleteConfirmationDialog = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="DeleteServicemodal-overlay">
            <div className="DeleteServicemodal-container">
                <h2 className="DeleteServicemodal-title">Confirm Delete</h2>
                <p className="DeleteServicemodal-message">Are you sure you want to delete this item?</p>
                <div className="DeleteServicemodal-actions">
                    <button onClick={onClose} className="DeleteServicebutton-cancel">
                        Cancel
                    </button>
                    <button onClick={onConfirm} className="DeleteServicebutton-delete">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationDialog;
